module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"s12eTitle":"Scope 1-2 Emissionen","energyEfficiencyTitle":"Energieeffizienz (Primärenergie)","heatingEfficiencyTitle":"Gebäudehülle (Raumwärme)","peRatioExplanation":"Gesamtenergieeffizienz nach SIA 2031:2016","rhRatioExplanation":"Effizienzklasse Gebäudehülle nach SIA 2031:2016"}}')
  delete Component.options._Ctor
}
